import type { JSX } from 'react';
import { Button } from '@/components/ui/button';
import type { CandidateProfile } from '../types/candidate-app.types';

export function ProfileEditForm({
  profile,
  onSubmit,
  onCancel,
}: {
  profile: CandidateProfile;
  onSubmit: (e: React.FormEvent<HTMLFormElement>) => void;
  onCancel: () => void;
}): JSX.Element {
  return (
    <form onSubmit={onSubmit} className="space-y-4">
      <input
        name="name"
        defaultValue={profile.name}
        placeholder="Full Name"
        required
        className="w-full px-3 py-2 border rounded"
      />
      <input
        name="phone"
        defaultValue={profile.phone || ''}
        placeholder="Phone"
        className="w-full px-3 py-2 border rounded"
      />
      <input
        name="country"
        defaultValue={profile.country || ''}
        placeholder="Country"
        className="w-full px-3 py-2 border rounded"
      />
      <div className="flex gap-2">
        <Button type="submit">Save</Button>
        <Button type="button" variant="outline" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    </form>
  );
}

export function ProfileView({ profile }: { profile: CandidateProfile }): JSX.Element {
  return (
    <div className="space-y-2">
      <p>
        <span className="font-medium">Name:</span> {profile.name}
      </p>
      <p>
        <span className="font-medium">Email:</span> {profile.email}
      </p>
      <p>
        <span className="font-medium">Company:</span> {profile.companyName}
      </p>
      <p>
        <span className="font-medium">Phone:</span> {profile.phone || 'Not set'}
      </p>
      <p>
        <span className="font-medium">Country:</span> {profile.country || 'Not set'}
      </p>
    </div>
  );
}
